import { Alert, Button, Card, Col, Empty, Row, Table } from 'antd';

const BillingCreditHistorySection = ({
  creditHistoryError,
  creditHistoryPage,
  creditHistoryLoading,
  creditHistoryItems,
  creditHistoryColumns,
  creditHistoryTotal,
  pageSize,
  onRefresh,
  onPageChange,
}) => (
  <Row gutter={[16, 16]}>
    <Col xs={24}>
      <Card
        className="billing-card"
        title="积分流水"
        extra={(
          <Button type="link" onClick={onRefresh} loading={creditHistoryLoading}>
            刷新
          </Button>
        )}
      >
        {creditHistoryError ? (
          <Alert
            type="error"
            showIcon
            message="加载失败"
            description={creditHistoryError}
            style={{ marginBottom: 12 }}
          />
        ) : null}
        <Table
          className="billing-history-table"
          size="middle"
          rowKey={(record) => String(record?.ledger_id || '')}
          dataSource={creditHistoryItems}
          columns={creditHistoryColumns}
          loading={creditHistoryLoading}
          pagination={{
            current: creditHistoryPage,
            pageSize,
            total: creditHistoryTotal,
            showSizeChanger: false,
            showTotal: (total) => `共 ${total} 条`,
            onChange: onPageChange,
          }}
          scroll={{ x: 720 }}
          locale={{
            emptyText: creditHistoryLoading
              ? '加载中...'
              : <Empty description="暂无积分流水" image={Empty.PRESENTED_IMAGE_SIMPLE} />,
          }}
        />
      </Card>
    </Col>
  </Row>
);

export default BillingCreditHistorySection;
